import en from './en/index.js'
import de from './de/index.js'

export default {
  'en': en,
  'de': de
}
